<template>
  <div v-bind:class="[authFlag == true ? 'login' : 'logout']">
    <main id="top" class="wrapper">
      <section class="keyVisual">
        <div class="keyVisualInner container">
          <div class="effectBlock effectBlock01"></div>
        </div>
      </section>
      <!-- .keyVisual -->
      <section class="topNews" v-if="notifications.length">
        <div class="topNewsInner container">
          <h2 class="topNewsTitle">
            <span>
              <svg width="55.923" height="18.5" viewBox="0 0 55.923 18.5">
                <path id="1492" data-name="パス 1492" d="M12.978,1.113V-16.758H10.269l.021,8.19c0,1.26.147,4.557.147,4.557S9.3-6.531,8.715-7.644L3.948-16.758H1.428V1.113H4.116V-7.833c0-1.323-.168-4.326-.168-4.326S5.061-9.6,5.523-8.652L10.5,1.113Zm12.348-.021V-1.491H19.719V-7.14h4.746v-2.6H19.719v-4.41h5.607v-2.583H16.905V1.092Zm16.737.021,3.948-17.871H43.134L41.223-6.72c-.294,1.6-.483,3.675-.672,5.145-.168-1.575-.42-3.885-.651-5.166L37.968-16.758H35.532L33.6-6.72c-.357,1.869-.5,3.948-.651,5.145-.147-1.281-.273-3.045-.672-5.145L30.366-16.758H27.51L31.521,1.113h2.793l1.932-9.891c.252-1.239.42-3.381.5-4.41.1,1.05.231,3.15.462,4.368L39,1.113ZM48.132.462a6.882,6.882,0,0,0,3.759.966c3.381,0,5.46-2.289,5.46-5.628,0-3.024-1.827-4.578-4.011-5.586a10.871,10.871,0,0,1-1.05-.5,2.208,2.208,0,0,1-1.47-2.184,1.9,1.9,0,0,1,2.079-1.89,4.666,4.666,0,0,1,3.066,1.092V-16.4a7.335,7.335,0,0,0-3.171-.672,4.435,4.435,0,0,0-4.725,4.662c0,2.247,1.134,3.843,3.444,4.872,1.449.672,2.919,1.428,2.919,3.36,0,2.142-1.239,2.919-2.457,2.919a5.461,5.461,0,0,1-3.843-1.554Z" transform="translate(-1.428 17.072)" fill="#E52B81"/>
              </svg>
            </span>
          </h2>
          <div class="topNewsList">
            <div class="splide jsSlide05" aria-label="">
              <div class="splide__track">
                <ul class="splide__list">
                  <li class="splide__slide" v-for="notification in notifications" :key="notification.id">
                    <dl>
                      <dt>{{notification.title}}</dt>
                      <dd>{{notification.content}}</dd>
                    </dl>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- topNews -->

      <section id="about" class="topAbout topAboutLogout" v-show="authFlag == false">
        <div class="topAboutInner container">
          <div class="effectBlock effectBlock06"></div>
          <h2 class="topAboutInnerTitle">
            <img src="/assets/img/top/aboutOtexTxtBlack.svg" alt="おかやまテクノロジー展 OTEXとは"><br/>
            <img src="/assets/img/top/aboutOtexTitleBlack.svg" alt="中四国最大級!ものづくり企業の展示商談会">
          </h2>
          <p>岡山県は、優れた技術や製品を持つ企業が多くあり、<br class="spNone">
            県内総生産のうち製造業の占める割合が全国平均を大きく上回る「ものづくり県」です。<br class="spNone">
            機械系ものづくり企業の展示商談会としては中四国最大級で、<br class="spNone">
            「ものづくり県おかやま」を広くアピールするため、2016年から開催。<br/>
            おかやまテクノロジー展2025をリアル展とあわせてオンラインで同時開催します。
          </p>
          <a class="linkSlash topSlideshowBtn">
            <picture>
              <source media="(min-width: 961px)" srcset="/assets/img/top/2025/aboutOtexBtntextBlack.svg?251125">
              <source media="(max-width: 960px)" srcset="/assets/img/top/2025/aboutOtexBtntextSpBlack.svg?251125">
              <img src="/assets/img/top/2025/aboutOtexBtntextBlack.svg?251125" alt="リアル展2025のスライドショーはこちら">
            </picture>
            <div class="linkSlashIcon">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7">
                <path d="M3.5,0,7,7H0Z" transform="translate(7) rotate(90)" fill="#fff" />
              </svg>
            </div>
          </a>
          <div class="topAboutInnerImg">
            <img src="/assets/img/top/aboutImg01.png" alt="OTEX OKAYAMA TECHNOLOGY EXHIBITION" width="416" height="132">
          </div>
          <iframe class="topAboutInnerVideo" src="https://www.youtube.com/embed/ZiW9j9MzTkQ?si=bcifdhER-HeD6XDu" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
      </section>
      <!-- topAbout ※ログイン前のセクション用 -->

      <section class="secPickup">

        <div class="secPickupIntro container containerLarge">
          <h2 class="h01 h01Pickup">
            <span class="h01Inner">
              <span class="h01Jp"><img src="/assets/img/common/txtPickupWhite.svg" alt="ピックアップ企業" width="259" height="40" ></span>
              <span class="h01En"><img src="/assets/img/common/txtPickupEnWhite.svg" alt="PICKUP"></span>
            </span>
          </h2>
          <div class="effectBlock effectBlock02"></div>
        </div>
        <div class="secPickupBtnarea container containerLarge">
          <router-link to="/company/" class="linkSlash linkSlashWhite">
            企業情報一覧はこちら
            <div class="linkSlashIcon">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7">
                <path d="M3.5,0,7,7H0Z" transform="translate(7) rotate(90)" fill="#10151a" />
              </svg>
            </div>
          </router-link>
        </div>
        <div class="secPickupSlide jsSlide01 splide" >
          <div class="splide__track">
            <ul class="splide__list">

              <li class="splide__slide" v-for="company in pickupCompanies" :key="company.id">
                <router-link :to="`/companyDetail?company_id=${company.id}`" class="secPickupSlideBox">
                  <div class="secPickupSlideBoxImg">
                    <img v-if="company.background_image_path" :src="company.background_image_path" alt="" @error="companyAltImg">
                    <img v-else src="/assets/img/company/companyKeyvisual.jpg" alt="{企業名}" />
                  </div>
                  <span class="secPickupSlideBoxTag">{{company.industry_name}}</span>
                  <span class="secPickupSlideBoxTitle">{{company.company_name}}</span>
                </router-link>
              </li>
            </ul>
          </div>
          <div class="splide__arrows">
            <button class="splide__arrow splide__arrow--prev">
              <img src="/assets/img/common/iconArrowSliderWhite.svg" alt="前へ">
            </button>
            <button class="splide__arrow splide__arrow--next">
              <img src="/assets/img/common/iconArrowSliderWhite.svg" alt="次へ">
            </button>
          </div>
        </div>
        <!-- slide -->
      </section>
      <!-- secPickup -->

      <div class="topSlideshow container">
        <iframe v-show="authFlag == true" class="topSlideshowVideo" src="https://www.youtube.com/embed/ZiW9j9MzTkQ?si=bcifdhER-HeD6XDu" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        <button class="topSlideshowBtn">
          <picture>
            <source media="(min-width: 961px)" srcset="/assets/img/top/2025/otexSlideshowBanner.png?251125">
            <source media="(max-width: 960px)" srcset="/assets/img/top/2025/otexSlideshowBannerSp.png?251125">
            <img src="/assets/img/top/2025/otexSlideshowBanner.png?251125" alt="">
          </picture>
        </button>
        <div class="effectBlock effectBlock03"></div>
      </div>
      <!-- topSlideshow -->

      <section class="topLecture" v-if="companyNewsData?.news?.length > 0">
        <div class="container">
          <div style="display: flex; justify-content: space-between; border-bottom: solid 3px #000; padding-bottom: 10px; margin-bottom: 10px;">
            <div class="updateNewsTitle">
              出展企業HP 更新情報
            </div>
            <div class="updateNewsLastDate">
              <!-- {{ companyNewsData.currentMonth }}月第{{ companyNewsData.currentWeekOfMonth }}週 -->
              最終更新日：{{ companyNewsData.news[0]?.created_at }}
            </div>
          </div>
          <div class="custom-scroll border-none">
            <ul>
              <li v-for="news in companyNewsData.news" :key="news.id" style="display: flex;">
                <a :href="news.url" target="_blank" rel="noopener noreferrer" @click="sendCompanyNewsLog(news.id)">
                  <div style="width: 100%;">{{ news.created_at }} <span style="font-weight: bolder;">{{ news.company_name }}</span></div>
                </a>
              </li>
            </ul>
          </div>
          <div style="text-align: end; font-size: smaller; margin-top: 10px;">
            外部サイトにリンクしています
          </div>
        </div>
      </section>

      <section class="topLecture">
        <div class="topLectureIntro container containerLarge">
          <h2 class="h01 h01Lecture">
            <span class="h01Inner">
              <span class="h01Jp"><img src="/assets/img/common/txtKichokouen.svg" alt="基調講演" width="142" height="40"  ></span>
              <span class="h01En"><img src="/assets/img/common/txtLecture.svg" alt="LECTURE"></span>
            </span>
          </h2>
          <div class="effectBlock effectBlock04"></div>
        </div>
        <div class="topLectureBtnarea container containerLarge">
          <router-link to="/lecture/" class="linkSlash">
            基調講演一覧はこちら
            <div class="linkSlashIcon">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7">
                <path d="M3.5,0,7,7H0Z" transform="translate(7) rotate(90)" fill="#fff" />
              </svg>
            </div>
          </router-link>
        </div>

        <div class="topLectureSlide jsSlide02 splide">
          <div class="splide__track">
            <ul class="splide__list">

              <li class="splide__slide" v-for="lecture in lectures" :key="lecture.id" @click="displayLecture(lecture)">

                <a class="linkLecture" v-if="lecture.webinar_flag == false">
                  <div class="linkLectureTxt">
                    <em>{{lecture.title}}</em>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="5" viewBox="0 0 40 5">
                      <path d="M0,0H40L35,5H0Z" fill="#e52b81" />
                    </svg>
                    <span>
                      <BrText :text="lecture.affiliate" />
                      {{lecture.instructor_name}}
                    </span>
                    <small v-if="lecture.video_url">基調講演を視聴する</small>
                  </div>
                  <div class="linkLectureImg">
                    <img v-if="lecture.instructor_image_path" :src="lecture.instructor_image_path" alt="" @error="lectureAltImg">
                    <img v-else src="/assets/img/top/lectureImg02.jpg" alt="{企業名}" />
                  </div>
                </a>

                <!--<a :href="lecture.video_url" class="linkLecture webinar" :target="[lecture.video_url ? '_blank' : '']" v-if="lecture.webinar_flag == true">-->
                <a class="linkLecture webinar" v-if="lecture.webinar_flag == true">
                  <span class="linkLectureTag"><span class="linkLectureTagInner">ウェビナー配信</span></span>
                  <div class="linkLectureTxt">
                    <em>{{lecture.title}}</em>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="5" viewBox="0 0 40 5">
                      <path d="M0,0H40L35,5H0Z" fill="#e52b81" />
                    </svg>
                    <span>{{lecture.affiliate}}<br />
                      {{lecture.instructor_name}}
                    </span>
                    <small v-if="lecture.video_url">配信ページへ移動する</small>
                  </div>
                  <div class="linkLectureImg">
                    <img v-if="lecture.instructor_image_path" :src="lecture.instructor_image_path" alt="" @error="lectureAltImg">
                    <img v-else src="/assets/img/top/lectureImg02.jpg" alt="{企業名}" />
                  </div>
                </a>

              </li>
            </ul>
          </div>
          <div class="splide__arrows">
            <button class="splide__arrow splide__arrow--prev">
              <img src="/assets/img/common/iconArrowSlider.svg" alt="前へ">
            </button>
            <button class="splide__arrow splide__arrow--next">
              <img src="/assets/img/common/iconArrowSlider.svg" alt="次へ">
            </button>
          </div>
        </div>

        <div class="modal">
          <div class="modalWrapper">
            <div class="modalInner">
              <div class="modalClose"><img src="/assets/img/common/iconPopupClose.svg" alt="閉じる" width="31" height="31"></div>
              <!-- contents -->
              <iframe width="560" height="315" src="https://www.youtube.com/embed/2Vtx09tpTvY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              <!-- contents -->
            </div>
            <!-- inner -->
          </div>
          <div class="modalBg"></div>
        </div>
        <!-- modal active付与で表示切り替え -->

      </section>
      <!-- topLecture -->

      <section class="topPresentation">
        <div class="topPresentationIntro container containerLarge">
          <h2 class="h01 h01Presentation">
            <span class="h01Inner">
              <span class="h01Jp">
                <picture>
                  <source media="(min-width: 961px)" srcset="/assets/img/common/txtShuttensya.svg">
                  <source media="(max-width: 960px)" srcset="/assets/img/common/txtShuttensyaSp.svg">
                  <img src="/assets/img/common/txtShuttensya.svg" alt="出展者プレゼンテーション" >
                </picture>
              </span>
              <span class="h01En"><img src="/assets/img/common/txtPresentation.svg" alt="PRESENTAITON" width="934" height="100" ></span>
            </span>
          </h2>
          <div class="effectBlock effectBlock05"></div>
        </div>
        <div class="topPresentationBtnarea container containerLarge">
          <router-link to="/presentation/" class="linkSlash linkSlash2row">
            出展者プレゼンテーション<br />一覧はこちら
            <div class="linkSlashIcon">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7">
                <path d="M3.5,0,7,7H0Z" transform="translate(7) rotate(90)" fill="#fff" />
              </svg>
            </div>
          </router-link>
        </div>

        <div class="topPresentationSlide jsSlide03 splide">
          <div class="splide__track">
            <ul class="splide__list">

              <li class="splide__slide" v-for="presentation in presentations" :key="presentation.id">
                <a v-bind:class="['linkPresentation', presentation.panel_color]" @click="displayPresentation(presentation.id)">
                  <div class="linkPresentationInner">
                    <span class="linkPresentationTitle">{{presentation.title}}</span>
                    <span v-bind:class="['linkPresentationTag', presentation.panel_color]">{{presentation.industry_name}}</span>
                    <span class="linkPresentationTxt">{{presentation.company_name}}</span>
                    <div class="linkPresentationTri linkPresentationTriLeft"></div>
                    <div class="linkPresentationTri linkPresentationTriRight"></div>
                  </div>
                </a>
              </li>
              <!--
              <li class="splide__slide">
                <a class="linkPresentation cat2">
                  <div class="linkPresentationInner">
                    <span class="linkPresentationTitle">プレゼンタイトルです</span>
                    <span class="linkPresentationTag">プレス・板金</span>
                    <span class="linkPresentationTxt">株式会社◯◯◯◯◯ ヤマダタロウ 氏</span>
                    <div class="linkPresentationTri linkPresentationTriLeft"></div>
                    <div class="linkPresentationTri linkPresentationTriRight"></div>
                  </div>
                </a>
              </li>
              -->
            </ul>
          </div>
          <div class="splide__arrows">
            <button class="splide__arrow splide__arrow--prev">
              <img src="/assets/img/common/iconArrowSlider.svg" alt="前へ">
            </button>
            <button class="splide__arrow splide__arrow--next">
              <img src="/assets/img/common/iconArrowSlider.svg" alt="次へ">
            </button>
          </div>
        </div>
      </section>
      <!-- topPresentation -->

      <section class="topKeyword">
        <div class="topKeywordIntro container containerLarge">
          <h2 class="h01 h01Keyword">
            <span class="h01Inner">
              <span class="h01Jp">
                <picture>
                  <source media="(min-width: 961px)" srcset="/assets/img/common/txtKeyword.svg">
                  <source media="(max-width: 960px)" srcset="/assets/img/common/txtKeywordSp.svg">
                  <img src="/assets/img/common/txtKeyword.svg" alt="キーワードから企業を探す" >
                </picture>
              </span>
              <span class="h01En"><img src="/assets/img/common/txtKeywordEn.svg" alt="KEYWORD" width="645" height="100"></span>
            </span>
          </h2>
        </div>
        <div class="topKeywordBtnarea container containerLarge">
          <router-link to="/company/" class="linkSlash">
            企業情報一覧はこちら
            <div class="linkSlashIcon">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7">
                <path d="M3.5,0,7,7H0Z" transform="translate(7) rotate(90)" fill="#fff" />
              </svg>
            </div>
          </router-link>
        </div>
        <div class="topKeywordList container containerLarge">
          <ul>
            <li><router-link to="/company" class="linkTag cat1" @click="industrySearch(1)">切削・研削</router-link></li>
            <li><router-link to="/company" class="linkTag cat2" @click="industrySearch(2)">鋳造・鍛造</router-link></li>
            <li><router-link to="/company" class="linkTag cat3" @click="industrySearch(3)">溶接・製缶</router-link></li>
            <li><router-link to="/company" class="linkTag cat4" @click="industrySearch(4)">プレス・板金</router-link></li>
            <li><router-link to="/company" class="linkTag cat5" @click="industrySearch(5)">金型・治具</router-link></li>
            <li><router-link to="/company" class="linkTag cat6" @click="industrySearch(6)">表面処理・熱処理・塗装</router-link></li>
            <li><router-link to="/company" class="linkTag cat7" @click="industrySearch(7)">電気・電子機器組立</router-link></li>
            <li><router-link to="/company" class="linkTag cat8" @click="industrySearch(8)">樹脂成形・ゴム加工</router-link></li>
            <li><router-link to="/company" class="linkTag cat9" @click="industrySearch(9)">設計・ソフト</router-link></li>
            <li><router-link to="/company" class="linkTag cat10" @click="industrySearch(10)">工具</router-link></li>
            <li><router-link to="/company" class="linkTag cat11" @click="industrySearch(11)">その他</router-link></li>
            <li><router-link to="/company" class="linkTag cat12" @click="industrySearch(12)">FA機器</router-link></li>
            <li><router-link to="/company" class="linkTag cat13" @click="industrySearch(13)">検査・測定機器</router-link></li>
            <li><router-link to="/company" class="linkTag cat14" @click="industrySearch(14)">生産設備関連</router-link></li>
            <li><router-link to="/company" class="linkTag cat15" @click="industrySearch(15)">AI・IoT</router-link></li>
            <li><router-link to="/company" class="linkTag cat16" @click="industrySearch(16)">自社製品</router-link></li>
            <li><router-link to="/company" class="linkTag cat17" @click="industrySearch(17)">素材</router-link></li>
            <li><router-link to="/company" class="linkTag cat18" @click="industrySearch(18)">ものづくり関連商社・サービス</router-link></li>
            <li><router-link to="/company" class="linkTag cat19" @click="industrySearch(19)">共同出展事務局</router-link></li>
            <li><router-link to="/company" class="linkTag cat20" @click="industrySearch(20)">企画展示</router-link></li>
            <li><router-link to="/company" class="linkTag cat21" @click="industrySearch(21)">工作機械展示</router-link></li>
          </ul>
        </div>
      </section>
      <!-- topKeyword -->

      <section id="about" class="topAbout topAboutLogin" v-show="authFlag == true">
        <div class="topAboutInner container">
          <div class="effectBlock effectBlock06"></div>
          <h2 class="topAboutInnerTitle">
            <img src="/assets/img/top/aboutOtexTxt.svg" alt="おかやまテクノロジー展 OTEXとは"><br/>
            <img src="/assets/img/top/aboutOtexTitle.svg" alt="中四国最大級!ものづくり企業の展示商談会">
          </h2>
          <p>岡山県は、優れた技術や製品を持つ企業が多くあり、<br class="spNone">
            県内総生産のうち製造業の占める割合が全国平均を大きく上回る「ものづくり県」です。<br class="spNone">
            機械系ものづくり企業の展示商談会としては中四国最大級で、<br class="spNone">
            「ものづくり県おかやま」を広くアピールするため、2016年から開催。<br/>
            おかやまテクノロジー展2025をリアル展とあわせてオンラインで同時開催します。
          </p>
          <a class="linkSlash linkSlashWhite topSlideshowBtn">
            <picture>
              <source media="(min-width: 961px)" srcset="/assets/img/top/2025/aboutOtexBtntext.svg">
              <source media="(max-width: 960px)" srcset="/assets/img/top/2025/aboutOtexBtntextSp.svg">
              <img src="/assets/img/top/2025/aboutOtexBtntext.svg" alt="リアル展2025のスライドショーはこちら">
            </picture>
            <div class="linkSlashIcon">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7">
                <path d="M3.5,0,7,7H0Z" transform="translate(7) rotate(90)" fill="#10151a" />
              </svg>
            </div>
          </a>
        </div>
      </section>
      <!-- topAbout -->

      <div class="popup" id="jsPopup1">
        <div class="popupWrapper">
          <div class="popupInner">
            <div class="popupClose"><img src="/assets/img/common/iconPopupClose.svg" alt="閉じる" width="31" height="31"></div>
              <div class="topRealExhibition popupItem">
                <div class="topRealExhibitionTxt">
                  <p class="topRealExhibitionTitle"><img src="/assets/img/top/2025/realExhibitionTitle.png" alt="おかやまテクノロジー展 2025 リアル展 スライドショー"></p>
                  <p>
                    OTEX2025リアル展は2日間で過去最高となる延べ13,392人にご来場いただき、好評の内に終了いたしました。多数のご来場ありがとうございました。
                  </p>
                  <dl>
                    <dt>開催日時</dt>
                    <dd>2025年11月12日 ～ 2025年11月13日</dd>
                    <dt>会場</dt>
                    <dd>コンベックス岡山 大・中・小展示場</dd>
                  </dl>
                </div>
                <div class="topRealExhibitionSlide">
                  <div class="jsSlide04 splide">
                    <div class="splide__track">
                      <ul class="splide__list">
                        <li class="splide__slide">
                          <img src="/assets/img/top/2025/real_1.jpg?251125" alt="">
                        </li>
                        <li class="splide__slide">
                          <img src="/assets/img/top/2025/real_2.jpg?251125" alt="">
                        </li>
                        <li class="splide__slide">
                          <img src="/assets/img/top/2025/real_3.jpg?251125" alt="">
                        </li>
                        <li class="splide__slide">
                          <img src="/assets/img/top/2025/real_4.jpg?251125" alt="">
                        </li>
                        <li class="splide__slide">
                          <img src="/assets/img/top/2025/real_5.jpg?251125" alt="">
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!-- slide -->
              </div>
              <!-- item -->
            </div>
            <!-- inner -->
          </div>
        </div>
        <div class="popupBg"></div>
      <!-- popup slideshow -->
    </main>
  </div>
</template>

<script setup>
  import { ref, onMounted, inject, watch, computed, onBeforeMount } from 'vue';
  import Splide from '@splidejs/splide';
  import FlashMessage from "../../components/FlashMessage.vue";
  import { onBeforeRouteLeave } from 'vue-router';
  import { useStore } from 'vuex';
  import router from '@/router';
  import axios from 'axios';
  import BrText from '@/components/BrText.vue';

  //store/index.jsのグローバルデータ
  const store = useStore();
  //main.jsで定義したグローバルaxios
  const $axios = inject('$axios');
  //変数
  const authFlag = computed(() => store.state.authFlag);
  const pickupCompanies = ref([]);
  const lectures = ref([]);
  const presentations = ref([]);
  const notifications = ref([]);
  const companyNewsData = ref();
  let splide1;
  let splide2;
  let splide3;
  let splideNews;
  let splide4;

  watch(authFlag, (newValue, oldValue) => {
    console.log('authFlag changed:', '新しい値:'+ newValue, '古い値:'+ oldValue);
  });

  const sendCompanyNewsLog = (companyNewsId) => {
    $axios.post('/api/log/company_news', { company_news_id: companyNewsId });
  }

  /**
   * 企業HPの最新情報を取得
   */
  const fetchCompanyNews = () => {
    $axios.get('/api/get_company_news')
      .then(res => {
        console.log(res.data);
        companyNewsData.value = res.data;
      })
      .catch(err => {
        console.error(err);
      });
  }

  //ピックアップ企業の取得
  const fetchPickUpCompany = () => {
    $axios.get('/api/get_pickup_companies')
      .then(res => {
        console.log(res.data.companies);
        pickupCompanies.value = res.data.companies;
      })
      .catch(err => {
        console.error(err);
      })
      .finally(()=> {
       
        splide1 = new Splide(".jsSlide01", { 
          updateOnMove: true,
          type: "loop",
          arrows: true,
          pagination: false,
          perPage: 3,
          perMove: 1,
          focus: "center",
          trimSpace: false,
          flickPower: 100,
          interval: 5000,
          speed: 400,
          autoplay: true,
          breakpoints: {
            960: {
              perPage: 1,
            },
          },
        });
        splide1.mount();

      });
  };

  //基調講演の取得
  const fetchUpLectures = () => {
    $axios.get('/api/get_pickup_lectures')
      .then(res => {
        console.log(res.data.lectures);
        lectures.value = res.data.lectures;
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {

        let jsSlide02 = document.querySelector('.jsSlide02');
        if(jsSlide02) {
          splide2 = new Splide(".jsSlide02", { 
            arrows: true,
            pagination: false,
            perMove: 1,
            pagination: true,
            trimSpace: false,
            flickPower: 300,
            fixedWidth: 580,
            gap: 40,
            breakpoints: {
              960: {
                fixedWidth: false,
                perPage: 1,
              },
            },
          });
          splide2.mount();
        }

      });
  }

  //出展者プレゼンテーションの取得
  const fetchUpPresentations = () => {
    $axios.get('/api/get_pickup_presentations')
      .then(res => {
        console.log(res.data.presentations);
        presentations.value = res.data.presentations;
      })
      .catch(err => {
        console.log(err);
      })
      .finally(()=> {

        let jsSlide03 = document.querySelector('.jsSlide02');
        if(jsSlide03) {
          splide3 = new Splide(".jsSlide03", { 
              arrows: true,
              perMove: 1,
              pagination: true,
              trimSpace: false,
              flickPower: 300,
              fixedWidth: 380,
              gap: 40,
              breakpoints: {
                960: {
                  fixedWidth: false,
                  perPage: 1,
                },
              },
          });
          splide3.mount();
        }
      });
  }

  //popup リアル展スライドショー
  const topSlideshowPopup = (e, btn) => {
    var popup = document.getElementById(e);
    if (!popup) return;
    var blackBg = document.querySelector(".popupBg");
    var closeBtn = document.querySelector(".popupClose");
    var showBtn = document.querySelectorAll(btn);
    showBtn.forEach(function (e) {
      e.addEventListener(
        "click",
        () => {
          popup.classList.toggle("popupShow");
          if (popup.classList.contains("popupShow") == true) {
            document.body.style.overflowY = "hidden";
          } else {
            document.body.style.overflowY = "auto";
          }
        },
        false
      );
    });

    function togglePopUp(elem) {
      if (!elem) return;
      elem.addEventListener("click", function () {
        popup.classList.toggle("popupShow");
        if (popup.classList.contains("popupShow") == true) {
          document.body.style.overflowY = "hidden";
        } else {
          document.body.style.overflowY = "auto";
        }
      });
    }

    togglePopUp(blackBg);
    togglePopUp(closeBtn);

  }

  //ニュースバーの情報取得
  const fetchNotifications = () => {
    $axios.get('/api/get_notifications')
      .then(res => {
        console.log(res.data.notifications);
        notifications.value = res.data.notifications;
      })
      .catch(err => {
        console.log(err);
      })
      .finally(()=> {
        if (notifications.value.length) {
          splideNews = new Splide(".jsSlide05", {
            direction: 'ttb',
            height: '5em',
            focus:'center',
            type:'loop',
            // autoHeight: true, //autoHeightを有効にするには、各.splide__slideの高さを固定にする必要
            arrows: false,
            pagination: false,
            interval: 5000,
            speed: 400,
            autoplay: true,
            rewind: true,
            breakpoints: {
              960: {
                height: '10em',
              },
            },
          });
          splideNews.mount();
        }
      });
  }

  //基調講演を押した時ページ遷移して表示させる処理
  const displayLecture = (lecture) => {

    //video_urlが設定されてなければこの後の処理は発火しない
    if (!lecture.video_url) {
      console.log('video_urlがないので遷移なし');
      return;
    }

    //もし認証してないときはログインにリダイレクトさせるようにするフラグをON
    if (authFlag.value == false) {
      store.commit('setUnAuthLinkFromTopPageFlag');
    }

    store.commit('setTopPageLectureInfo', lecture);
    router.push('/lecture');
  }

  //プレゼンテーションを押した時ページ遷移して表示させる処理
  const displayPresentation = (presentationId) => {

    //もし認証してないときはログインにリダイレクトさせるようにするフラグをON
    if (authFlag.value == false) {
      store.commit('setUnAuthLinkFromTopPageFlag');
    }

    store.commit('setTopPagePresentationFlagNum', presentationId);
    router.push('/presentation');
  }

  //キーワードから検索のところの処理（カテゴリー検索）
  const industrySearch = (num) => {
    store.commit('setIndustryTopSearch', "industry_check_" + num);
  }

  const companyAltImg = (event) => {
    event.target.src = "/assets/img/top/pickupThumb03.jpg"; 
  }

  const lectureAltImg = (event) => {
      event.target.src = "/assets/img/top/lectureImg01.jpg"; 
  }

  const gtagAccessTopPage = () => {
    //topページにきたのでアクセスしたログを送る
    let currentUser = store.state.currentUser

    // ログイン済みの場合
    if (currentUser.role) {
      window.gtag('event', "custom_user_event", {
        'event_category': "page_view",
        'event_label': "PV",
        'user_role': currentUser.role,
        'value' : 1
      });
      console.log('send page_view')

      //ログインユーザーでログを取れたらその後二重ログとり防止
      store.commit('setTopPageLogSubmittedFlag');

    } else {
      // 未ログイン時
      window.gtag('event', "custom_user_event", {
        'event_category': "page_view",
        'event_label': "PV",
        'user_role': 10,
        'value' : 1
      });
      console.log('send not login page_view')
    }
  }

  // 学生アカウントのログを送信する
  const gtagStudentTopPage = () => {
        const user = store.state.currentUser
        if (!user) return

        // 学生ログ送信済みの場合
        if (store.state.isSubmittedTopPageStudentLog) {
            return
        }

        window.gtag('event', "custom_user_event", {
            'event_category': "page_view_student",
            'event_label': user.name,
            'value' : 1
        });
        
        // 学生アカウントログを送信済みとして保持
        store.commit('setIsSubmittedTopPageStudentLog')

        console.log('send page_view_student')
    }

  //mountedより前に発火
	onBeforeMount(() => {
    fetchCompanyNews();
    fetchPickUpCompany();
    fetchUpLectures();
    fetchUpPresentations();
    fetchNotifications();
  })
  // mounted 
  onMounted(() => {

    if (store.state.topPageLogSubmittedFlag == false) {
      gtagAccessTopPage();
    }

    // 学生がトップページを訪問した場合、学生アカウントのログを送信する
    if (store.state.currentUser?.role_id == 4) {
        gtagStudentTopPage()
    }

    topSlideshowPopup("jsPopup1", ".topSlideshowBtn");
    //※splideの初期化はmounted内で定義しないとうまくいかないのでこのように対応
    splide4 = new Splide(".jsSlide04", { 
      arrows: true,
      perMove: 1,
      pagination: true,
      trimSpace: false,
      flickPower: 300,
      interval: 5000,
      speed: 400,
      autoplay: true,
      classes: {
        arrow: 'splide__arrow splide4-arrow',
        prev: 'splide__arrow--prev splide4-prev',
        next: 'splide__arrow--next splide4-next',
      }
    });
    splide4.mount();

    //重複初期化を避けるために要素をページ離脱前に削除
    onBeforeRouteLeave((to, from, next) => {
      setTimeout(() => {
        splide1.destroy();
        splide4.destroy();
        //splide2 && splide3はログアウト中は存在しないので除外
        if (splide2 && splide3) {
          splide2.destroy();
          splide3.destroy();
        }
        if (splideNews) {
          splideNews.destroy();
        }
      }, 1000);

      next();
    });
  });
</script>

<style scoped>
.updateNewsTitle {
  font-weight: bold; 
  font-size: 1.4em;
  align-content: center;
  @media screen and (max-width: 960px) {
    font-size: 1em;
  }
}
.updateNewsLastDate {
  font-weight: bolder; 
  font-size: 1em;
  align-content: center;
  @media screen and (max-width: 960px) {
    font-size: 0.8em;
  }
}
.custom-scroll {
  max-height: 480px;
  overflow-y: auto;
  
  /* Firefox用: トラックの色を transparent に設定 */
  scrollbar-color: #E52B81 #E8E8E8;
  scrollbar-width: 15px;

  @media screen and (max-width: 960px) {
    max-height: 300px;
  }
}

/* Webkit系ブラウザ用: トラックの背景を transparent に設定 */
.custom-scroll::-webkit-scrollbar-track {
  background-color: transparent; /* 背景を透明にする */
}

/* 以下はつまみのスタイル（画像のピンク色を再現） */
.custom-scroll::-webkit-scrollbar {
  width: 15px;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background-color: #E52B81;
  border-radius: 4px;
}

.custom-scroll ul li a {
  padding: 15px 10px;
  text-decoration: none;
  width: 100%;
  color: black;
  border-bottom: solid 1px black;
}

.custom-scroll ul li a:hover {
  background-color: #f0f0f0; /* ホバー時の背景色 */
}
</style>